<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header title="Withdrawal record" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div class="mt-5" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
            <div class="item mb-5" v-for="item in logList" :key="item.log_id">
                <div class="mt-wrapper">
                    <div class="mt">
                        <h2>Available funds:{{item.store_avaliable_money}}</h2>
                    </div>
                    <div class="mt">
                        <h2>Frozen funds:{{item.store_freeze_money}}</h2>
                    </div>
                </div>
                <div class="mc">
                    {{item.storemoneylog_desc}}
                </div>
                <div class="time"> {{ $moment.unix(item.storemoneylog_add_time).format('YYYY-MM-DD h:mm:ss') }}</div>
            </div>
            <empty-record v-if="logList && !logList.length"></empty-record>
        </div>
    </div>
</template>

<script>
import { Indicator } from 'mint-ui'
import EmptyRecord from '../../../components/EmptyRecord'
import { getSellerMoneyWithdrawList } from '../../../api/sellerMoney'
export default {
  name: 'LogList',
  components: {
    EmptyRecord
  },
  data () {
    return {
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      logList: false // 记录列表
    }
  },
  methods: {
    getLogList (ispush) {
      Indicator.open()
      let params = this.params
      getSellerMoneyWithdrawList(params).then(res => {
        Indicator.close()

        if (ispush && this.logList) {
          this.logList = this.logList.concat(res.result.log_list)
        } else {
          this.logList = res.result.log_list
        }
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }
      })
    },
    loadMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getLogList(true)
      }
    }
  }
}
</script>

<style scoped>
    .item{padding:.5rem;background:#fff;}
    .item .mt-wrapper{display: flex}
    .item .mt{height:2rem;line-height:2rem;flex:1}
    .item .mt h2{font-weight:bold;font-size:.7rem}
    .item .time{font-size:.6rem;color:gray}
    .item .mc{padding-top:.5rem;line-height:1rem;font-size:.8rem;}
</style>
